import {Component, Input, OnInit} from '@angular/core';
import {Aangifte} from "@snelstart-ventures/fiscaal/domain-logic";
import {BehaviorSubject} from "rxjs";
import { JaarruimtegegevensComponent } from './jaarruimtegegevens/jaarruimtegegevens.component';
import { LijfrentePremiesComponent } from './lijfrente-premies/lijfrente-premies.component';


@Component({
  selector: 'snelstart-venture-fiscaal-feature-lijfrente',
  templateUrl: './lijfrente.component.html',
  styleUrls: ['./lijfrente.component.scss'],
  imports: [
    JaarruimtegegevensComponent,
    LijfrentePremiesComponent
  ]
})
export class LijfrenteComponent  {

    @Input() public id!: string;
    public aangifte = <Aangifte>{};

    @Input() partner = new BehaviorSubject<boolean>(false);

}
